// source: mti/store/lock/state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var mti_metadata_pb = require('../../../mti/metadata_pb.js');
goog.object.extend(proto, mti_metadata_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.mti.store.lock.KeyType', null, global);
goog.exportSymbol('proto.mti.store.lock.LockFailureType', null, global);
goog.exportSymbol('proto.mti.store.lock.State', null, global);
goog.exportSymbol('proto.mti.store.lock.Type', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mti.store.lock.State = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.mti.store.lock.State, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mti.store.lock.State.displayName = 'proto.mti.store.lock.State';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mti.store.lock.State.prototype.toObject = function(opt_includeInstance) {
  return proto.mti.store.lock.State.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mti.store.lock.State} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.lock.State.toObject = function(includeInstance, msg) {
  var f, obj = {
    metadata: (f = msg.getMetadata()) && mti_metadata_pb.Metadata.toObject(includeInstance, f),
    storeId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    serialNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
    lockIndex: jspb.Message.getFieldWithDefault(msg, 4, 0),
    stateUuid: msg.getStateUuid_asB64(),
    stateUpdatedAt: (f = msg.getStateUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 7, 0),
    lockModel: jspb.Message.getFieldWithDefault(msg, 8, ""),
    lockHardwareVersion: jspb.Message.getFieldWithDefault(msg, 9, ""),
    lockFirmwareVersion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    lostCommunication: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    identifying: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    lockOpen: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    lockStuck: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    lockArmed: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    lockLocked: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    lockAlarming: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    lockDoorAlarm: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    lockPullAlarm: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    authorizedUserKeyUsed: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    lockBatteryLevel: jspb.Message.getFieldWithDefault(msg, 16, 0),
    silentAlarming: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    keySerialNumber: jspb.Message.getFieldWithDefault(msg, 18, ""),
    keyType: jspb.Message.getFieldWithDefault(msg, 19, 0),
    failureType: jspb.Message.getFieldWithDefault(msg, 22, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mti.store.lock.State}
 */
proto.mti.store.lock.State.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mti.store.lock.State;
  return proto.mti.store.lock.State.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mti.store.lock.State} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mti.store.lock.State}
 */
proto.mti.store.lock.State.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mti_metadata_pb.Metadata;
      reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStoreId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSerialNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLockIndex(value);
      break;
    case 5:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setStateUuid(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStateUpdatedAt(value);
      break;
    case 7:
      var value = /** @type {!proto.mti.store.lock.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockModel(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockHardwareVersion(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLockFirmwareVersion(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLostCommunication(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIdentifying(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockOpen(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockStuck(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockArmed(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockLocked(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockAlarming(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockDoorAlarm(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLockPullAlarm(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAuthorizedUserKeyUsed(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLockBatteryLevel(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSilentAlarming(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeySerialNumber(value);
      break;
    case 19:
      var value = /** @type {!proto.mti.store.lock.KeyType} */ (reader.readEnum());
      msg.setKeyType(value);
      break;
    case 22:
      var value = /** @type {!proto.mti.store.lock.LockFailureType} */ (reader.readEnum());
      msg.setFailureType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mti.store.lock.State.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mti.store.lock.State.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mti.store.lock.State} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mti.store.lock.State.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mti_metadata_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getStoreId();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getSerialNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLockIndex();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getStateUuid_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      5,
      f
    );
  }
  f = message.getStateUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getLockModel();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLockHardwareVersion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getLockFirmwareVersion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLostCommunication();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getIdentifying();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getLockOpen();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getLockStuck();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getLockArmed();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getLockLocked();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getLockAlarming();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getLockDoorAlarm();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getLockPullAlarm();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getAuthorizedUserKeyUsed();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getLockBatteryLevel();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getSilentAlarming();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getKeySerialNumber();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getKeyType();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getFailureType();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
};


/**
 * optional mti.Metadata metadata = 1;
 * @return {?proto.mti.Metadata}
 */
proto.mti.store.lock.State.prototype.getMetadata = function() {
  return /** @type{?proto.mti.Metadata} */ (
    jspb.Message.getWrapperField(this, mti_metadata_pb.Metadata, 1));
};


/**
 * @param {?proto.mti.Metadata|undefined} value
 * @return {!proto.mti.store.lock.State} returns this
*/
proto.mti.store.lock.State.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 store_id = 2;
 * @return {number}
 */
proto.mti.store.lock.State.prototype.getStoreId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setStoreId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string serial_number = 3;
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getSerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setSerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 lock_index = 4;
 * @return {number}
 */
proto.mti.store.lock.State.prototype.getLockIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bytes state_uuid = 5;
 * @return {!(string|Uint8Array)}
 */
proto.mti.store.lock.State.prototype.getStateUuid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * optional bytes state_uuid = 5;
 * This is a type-conversion wrapper around `getStateUuid()`
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getStateUuid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getStateUuid()));
};


/**
 * optional bytes state_uuid = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getStateUuid()`
 * @return {!Uint8Array}
 */
proto.mti.store.lock.State.prototype.getStateUuid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getStateUuid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setStateUuid = function(value) {
  return jspb.Message.setProto3BytesField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp state_updated_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.mti.store.lock.State.prototype.getStateUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.mti.store.lock.State} returns this
*/
proto.mti.store.lock.State.prototype.setStateUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.clearStateUpdatedAt = function() {
  return this.setStateUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.hasStateUpdatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Type type = 7;
 * @return {!proto.mti.store.lock.Type}
 */
proto.mti.store.lock.State.prototype.getType = function() {
  return /** @type {!proto.mti.store.lock.Type} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.mti.store.lock.Type} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string lock_model = 8;
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getLockModel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockModel = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string lock_hardware_version = 9;
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getLockHardwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockHardwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string lock_firmware_version = 10;
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getLockFirmwareVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockFirmwareVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool lost_communication = 11;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLostCommunication = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLostCommunication = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool identifying = 12;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getIdentifying = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setIdentifying = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool lock_open = 13;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool lock_stuck = 14;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockStuck = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockStuck = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool lock_armed = 17;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockArmed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockArmed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional bool lock_locked = 20;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockLocked = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockLocked = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional bool lock_alarming = 15;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockAlarming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockAlarming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional bool lock_door_alarm = 23;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockDoorAlarm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockDoorAlarm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool lock_pull_alarm = 24;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getLockPullAlarm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockPullAlarm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional bool authorized_user_key_used = 21;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getAuthorizedUserKeyUsed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setAuthorizedUserKeyUsed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional uint32 lock_battery_level = 16;
 * @return {number}
 */
proto.mti.store.lock.State.prototype.getLockBatteryLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setLockBatteryLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional bool silent_alarming = 25;
 * @return {boolean}
 */
proto.mti.store.lock.State.prototype.getSilentAlarming = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setSilentAlarming = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional string key_serial_number = 18;
 * @return {string}
 */
proto.mti.store.lock.State.prototype.getKeySerialNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setKeySerialNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional KeyType key_type = 19;
 * @return {!proto.mti.store.lock.KeyType}
 */
proto.mti.store.lock.State.prototype.getKeyType = function() {
  return /** @type {!proto.mti.store.lock.KeyType} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.mti.store.lock.KeyType} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setKeyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional LockFailureType failure_type = 22;
 * @return {!proto.mti.store.lock.LockFailureType}
 */
proto.mti.store.lock.State.prototype.getFailureType = function() {
  return /** @type {!proto.mti.store.lock.LockFailureType} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.mti.store.lock.LockFailureType} value
 * @return {!proto.mti.store.lock.State} returns this
 */
proto.mti.store.lock.State.prototype.setFailureType = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * @enum {number}
 */
proto.mti.store.lock.Type = {
  POWERED: 0,
  BATTERY: 1
};

/**
 * @enum {number}
 */
proto.mti.store.lock.KeyType = {
  NONE: 0,
  USB_BACKUP: 1,
  USB_NETWORK: 2,
  RFID_USER: 3,
  RFID_PROGRAMMING: 4,
  RFID_FACTORY_RESET: 5,
  RFID_CONNECT: 6,
  NFC_USER: 16,
  NFC_CONNECT: 17,
  BLE_USER: 32,
  BLE_CONNECT: 33
};

/**
 * @enum {number}
 */
proto.mti.store.lock.LockFailureType = {
  FAIL_OPEN: 0,
  FAIL_SECURE: 1
};

goog.object.extend(exports, proto.mti.store.lock);
